const textField = {
    styleOverrides: {
        root: {
            /*[breakpoints.down('md')]: {
                marginTop: pxToRem(25),
            },
            [breakpoints.down('sm')]: {
                marginTop: pxToRem(20),
            },*/
        },
        label: {
            /*textAlign: 'center',
            color: colors.white.main,*/
        },
    },
};

export default textField;
